import type { FC, FormEvent, ReactNode } from 'react'

import Link from 'next/link'
import { useState } from 'react'
import { apiFetch } from '@/lib/client'
import PageShell from '@/components/generals/page-shell'

import {
    buttonPrimary,
    cardClassName,
    Field,
    inputClassName,
    Notice,
    Spinner
} from '@/components/generals/ui'

const ForgotPasswordPage: FC = (): ReactNode => {
    const [email, setEmail] = useState('')
    const [submitting, setSubmitting] = useState(false)
    const [error, setError] = useState('')
    const [done, setDone] = useState('')

    const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()

        if (submitting) return

        setSubmitting(true)
        setError('')

        const result = await apiFetch<{ message: string }>('/api/auth/forgot', { body: { email: email.trim() } })

        setSubmitting(false)

        if (!result.ok) return setError(result.message)

        setDone(result.data.message)
    }

    return (
        <PageShell title='Lupa password' width='narrow'>
            <h1 className='font-heading font-soft text-4xl font-medium tracking-[-0.03em]'>Lupa password</h1>

            <p className='mt-2 text-cream/65'>
                Masukkan email akunmu. Kami kirim link untuk membuat password baru.
            </p>

            {done ? (
                <div className={`${cardClassName} mt-8`}>
                    <Notice tone='success'>{done}</Notice>

                    <Link href='/masuk' className={`${buttonPrimary} mt-5 w-full`}>
                        Kembali ke halaman masuk
                    </Link>
                </div>
            ) : (
                <form noValidate onSubmit={onSubmit} className={`${cardClassName} mt-8 flex flex-col gap-4`}>
                    <Field label='Email' htmlFor='forgot-email'>
                        <input
                            id='forgot-email'
                            type='email'
                            inputMode='email'
                            autoComplete='email'
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            className={inputClassName}
                        />
                    </Field>

                    {error && <Notice tone='error'>{error}</Notice>}

                    <button type='submit' disabled={submitting} className={buttonPrimary}>
                        {submitting && <Spinner />}
                        Kirim link reset
                    </button>

                    <Link href='/masuk' className='text-center text-sm text-cream/65 underline-offset-4 hover:text-cream hover:underline'>
                        Ingat password? Masuk
                    </Link>
                </form>
            )}
        </PageShell>
    )
}

export default ForgotPasswordPage
